import React from 'react';
import styles from './Spinner.module.css';

const Spinner = () => {
  return (
    <div className={styles.loadWrap}>
      <div className={styles.loader}>Loading</div>
    </div>
  );
};

Spinner.displayName = 'Spinner';
export default Spinner;
